import { OCCUPATION_DATA, CUISINE_DATA } from '../../../../constants/progressBanner'
import { JOB_DUTIES_BY_OCCUPATION, DEFAULT_JOB_DUTIES } from './ResumeAutoGenerateModal.constants'

const MILLISECONDS_PER_SECOND = 1000
const SECONDS_PER_MINUTE = 60
const MINUTES_PER_HOUR = 60
const HOURS_PER_DAY = 24
const DAYS_PER_YEAR = 365

export const getGenreName = (genreId: number | null): string => {
    if (!genreId) return ''
    for (const category of Object.values(CUISINE_DATA)) {
        const genre = category.find(g => g.genreId === genreId)
        if (genre) return genre.name
    }
    return ''
}

export const getOccupationName = (occupationId: number | null): string => {
    if (!occupationId) return ''
    for (const category of Object.values(OCCUPATION_DATA)) {
        const occupation = category.find(o => o.occupationId === occupationId)
        if (occupation) return occupation.name
    }
    return ''
}

export const getJobDutiesByOccupation = (
    occupationId: number | null
): string[] => {
    if (!occupationId) return DEFAULT_JOB_DUTIES

    return JOB_DUTIES_BY_OCCUPATION[occupationId] || DEFAULT_JOB_DUTIES
}

export const calculateWorkYears = (
    startYear: string,
    startMonth: string,
    endYear: string | null,
    endMonth: string | null
): string => {
    if (!startYear || !startMonth) return ''

    const start = new Date(parseInt(startYear), parseInt(startMonth) - 1)
    const end = endYear && endMonth
        ? new Date(parseInt(endYear), parseInt(endMonth) - 1)
        : new Date()

    const diffTime = Math.abs(end.getTime() - start.getTime())
    const millisecondsPerYear = MILLISECONDS_PER_SECOND * SECONDS_PER_MINUTE * MINUTES_PER_HOUR * HOURS_PER_DAY * DAYS_PER_YEAR
    const diffYears = Math.floor(diffTime / millisecondsPerYear)

    return diffYears.toString()
}
